import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, Spinner } from 'reactstrap';

interface LoaderModalProps {
  isOpen: boolean;
  error?: string;
  onClose: () => void;
}

const LoaderModal: React.FC<LoaderModalProps> = ({
  isOpen,
  error,
  onClose,
}) => {
  const [visible, setVisible] = useState(isOpen);

  useEffect(() => {
    setVisible(isOpen);
  }, [isOpen]);

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        setVisible(false);
        onClose();
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [error, onClose]);

  return (
    <Modal isOpen={visible} backdrop="static" keyboard={false} centered>
      <ModalBody className="text-center py-5">
        {!error ? (
          <>
            <Spinner color="primary" />
            <div className="mt-2 text-muted fs-5">Processing...</div>
          </>
        ) : (
          <div className="text-danger fs-6">{error}</div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default LoaderModal;
